export const faqsPl = [
  {
    q: "Czym różni się MVP aplikacji od MVP urządzenia?",
    a: "Proces jest ten sam: wąski zakres, kryteria sukcesu i walidacja z użytkownikami. Różni się stack — app/SaaS to web lub mobile + backend, urządzenie IoT dodaje elektronikę, firmware i łączność. Zakres MVP zawsze tnemy do minimum potrzebnego do testu hipotezy.",
  },
  {
    q: "Jak szybko można zbudować proste MVP?",
    a: "Proste MVP webowe (logowanie, dashboard, kluczowa funkcja) to zwykle 6–12 tygodni. MVP mobilne lub z AI — częściej 2–4 miesiące. MVP urządzenia na DevKit to zwykle 2–4 miesiące. Terminy typu 3–5 tygodni są realistyczne tylko przy bardzo wąskim zakresie i gotowym designie.",
  },
  {
    q: "Czy budujecie MVP z gotowego projektu w Figmie?",
    a: "Tak. Jeśli masz makiety lub prototyp UX, skracamy discovery i od razu idziemy w architekturę, wycenę i development. Jeśli Figmy nie ma, zaczynamy od warsztatów produktowych.",
  },
  {
    q: "Czy robicie MVP z AI / OpenAI / chatbotem?",
    a: "Tak — traktujemy AI jako cechę produktu, nie osobną usługę. Typowe MVP: katalog z rekomendacjami, panel admina, integracja API LLM, logowanie i podstawowe powiadomienia. Ważne: najpierw hipoteza biznesowa, potem model.",
  },
  {
    q: "Czy możecie zrobić MVP przy ograniczonym budżecie?",
    a: "Tak, ale wtedy tniemy zakres, nie jakość. Lepiej wypuścić jedną ścieżkę użytkownika dobrze, niż pół produktu „na wszystko”. Na warsztatach pomagamy ustalić, co zostaje w MVP, a co idzie do backlogu.",
  },
  {
    q: "Czy potrzebuję NDA przed wyceną?",
    a: "Często tak — zwłaszcza przy AI, medtechu i produktach B2B. Podpisujemy NDA przed briefem ze szczegółami IP, a potem robimy wycenę i proponujemy model współpracy (stała cena lub Time & Material).",
  },
  {
    q: "Fixed price czy Time & Material przy MVP?",
    a: "Stała cena ma sens, gdy zakres jest domknięty po warsztatach. Time & Material lepiej działa, gdy odkrywacie produkt w trakcie. Często łączymy: stała cena na pierwszy etap, potem Time & Material na iteracje po feedbacku.",
  },
  {
    q: "Czy MVP obejmuje też urządzenie BLE / IoT?",
    a: "Tak. Budujemy MVP aplikacji z BLE, prototypów wearable i prostych systemów IoT — często startując od DevKit (Nordic, ESP32, STM32), zanim inwestujesz we własną PCB.",
  },
] as const;
